import { numberToPrettyString } from '@cian/utils/lib/shared/number_helpers';
import { useSelector } from 'react-redux';

import { IOfferSummaryInfoItemProps } from '../../../../../components/OfferSummaryInfo';
import {
  AccessTypeNames,
  ConditionTypeNames,
  LayoutNames,
  ParkingTypeNames,
} from '../../../../../components/additional_features/locales';
import { offerSelector, selectParkingFree } from '../../../../../selectors';
import { getOfferType, isCommercial } from '../../../../../utils/offer_type';
import { useSummaryInfoBuildingProps } from '../../OfferSummaryInfoBuilding/hooks/useSummaryInfoBuildingProps';

export interface IUseSummaryInfoCommercialProps {
  rightGroup: boolean;
  summaryInfoItems: IOfferSummaryInfoItemProps[];
}

export const useSummaryInfoCommercialProps = (): IUseSummaryInfoCommercialProps | null => {
  const offer = useSelector(offerSelector);
  const parking = useSelector(selectParkingFree);

  const buildingProps = useSummaryInfoBuildingProps();

  const offerType = getOfferType(offer);

  const isCommercialOffer = isCommercial(offerType);

  if (!isCommercialOffer) {
    return null;
  }

  const summaryInfoItems: IOfferSummaryInfoItemProps[] = [];

  if (offer.taxNumber) {
    summaryInfoItems.push({
      name: 'Номер налоговой',
      value: offer.taxNumber,
    });
  }
  summaryInfoItems.push({
    name: 'Юридический адрес',
    value: offer.isLegalAddressProvided ? 'Предоставляется' : 'Не предоставляется',
  });

  if (offer.building && !!offer.building.ceilingHeight) {
    summaryInfoItems.push({
      name: 'Высота потолков',
      value: `${numberToPrettyString(Number(offer.building.ceilingHeight))} м`,
    });
  }

  if (offer.layout) {
    summaryInfoItems.push({
      name: 'Планировка',
      value: LayoutNames[offer.layout],
    });
  }

  if (offer.conditionType) {
    summaryInfoItems.push({
      name: 'Состояние',
      value: ConditionTypeNames[offer.conditionType],
    });
  }

  if (offer.accessType) {
    summaryInfoItems.push({
      name: 'Доступ',
      value: AccessTypeNames[offer.accessType],
    });
  }

  if (offer.building?.parking?.type) {
    summaryInfoItems.push({
      name: 'Парковка',
      value: ParkingTypeNames[offer.building.parking.type],
    });
  }

  if (parking) {
    summaryInfoItems.push({
      name: 'Стоимость парковки',
      value: parking,
    });
  }

  return {
    rightGroup: Boolean(buildingProps),
    summaryInfoItems,
  };
};
